<div>
  {{ timer$ | async }}
</div>
